import React from 'react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="gt-footer gt-style-2" style={styles.footer}>
      <div className="container">
        <div className="gt-footer-content">
          {/* Desktop Footer */}
          <div className="vc_row wpb_row vc_row-fluid mobile-hide" style={styles.desktopFooter}>
            {/* Logo Column */}
            <div className="footer__four wpb_column vc_column_container" style={styles.logoColumn}>
              <div className="wpb_single_image footer_logo">
                <figure className="wpb_wrapper vc_figure">
                  <div className="vc_single_image-wrapper">
                    <img 
                      width="97" 
                      height="160" 
                      src="https://iwlf.in/wp-content/uploads/2025/06/iwlf-footer-logo.png" 
                      alt="IWLF Footer Logo" 
                      loading="lazy"
                      style={styles.logoImg}
                    />
                  </div>
                </figure>
              </div>
            </div>

            {/* Main Menu Column */}
            <div className="wpb_column vc_column_container" style={styles.column}>
              <div className="gt-heading gt-dark gt-size2 gt-align-left">
                <div className="gt-title" style={styles.columnTitle}>Main Menu</div>
              </div>
              <div style={{ height: '25px' }}></div>
              <ul className="footer_menu" style={styles.linkList}>
                <li><a href="https://iwlf.in/?page_id=2893" style={styles.link}>About us</a></li>
                <li><a href="https://iwlf.in/?page_id=2915" style={styles.link}>National Camps</a></li>
                <li><a href="https://iwlf.in/?page_id=3075" style={styles.link}>RTI</a></li>
                <li><a href="https://iwlf.in/terms-of-service/" style={styles.link}>Terms of Service</a></li>
                <li><a href="https://iwlf.in/privacy-policy/" style={styles.link}>Privacy Policy</a></li>
                <li><a href="https://iwlf.in/refund-policy/" style={styles.link}>Refund Policy</a></li>
                <li><a href="https://iwlf.in/category/news/" style={styles.link}>Actual News</a></li>
              </ul>
            </div>

            {/* Quick Links Column */}
            <div className="wpb_column vc_column_container" style={styles.column}>
              <div className="gt-heading gt-dark gt-size2 gt-align-left">
                <div className="gt-title" style={styles.columnTitle}>Quick links</div>
              </div>
              <div style={{ height: '25px' }}></div>
              <ul className="footer_menu" style={styles.linkList}>
                <li><a href="http://www.yas.nic.in" target="_blank" rel="noopener noreferrer" style={styles.link}>Ministry of Youth Affairs & Sports</a></li>
                <li><a href="http://www.sportsauthorityofindia.nic.in" target="_blank" rel="noopener noreferrer" style={styles.link}>Sports Authority of India</a></li>
                <li><a href="http://www.nada.nic.in" target="_blank" rel="noopener noreferrer" style={styles.link}>National Anti-Doping Agency</a></li>
                <li><a href="http://www.iwf.net" target="_blank" rel="noopener noreferrer" style={styles.link}>International Weightlifting Federation</a></li>
                <li><a href="http://www.a-w-f.net/" target="_blank" rel="noopener noreferrer" style={styles.link}>Asian Weightlifting Federation</a></li>
                <li><a href="http://www.iwf.net/results/results-by-events/" target="_blank" rel="noopener noreferrer" style={styles.link}>International Result</a></li>
                <li><a href="http://www.commonwealthweightlifting.com/" target="_blank" rel="noopener noreferrer" style={styles.link}>Commonwealth Weightlifting Federation</a></li>
              </ul>
            </div>

            {/* Contact Column */}
            <div className="wpb_column vc_column_container" style={styles.column}>
              <div className="gt-heading gt-dark gt-size2 gt-align-left">
                <div className="gt-title" style={styles.columnTitle}>Let's Connect</div>
              </div>
              <div style={{ height: '25px' }}></div>
              <div className="gt-icon-list gt-style-1">
                <ul style={styles.iconList}>
                  <li style={styles.contactItem}>
                    <i className="fas fa-solid fa-phone" style={styles.icon}></i>
                    <div className="text">0091-120-4541605</div>
                  </li>
                  <li style={styles.contactItem}>
                    <i className="fas fa-solid fa-envelope" style={styles.icon}></i>
                    <div className="text">weightlifting@weightliftingindia.in</div>
                  </li>
                  <li style={styles.contactItem}>
                    <i className="fas fa-solid fa-globe" style={styles.icon}></i>
                    <div className="text">www.iwlf.in</div>
                  </li>
                  <li style={styles.contactItem}>
                    <i className="fas fa-map-marker-alt" style={styles.icon}></i>
                    <div className="text">Shri S.H. Anande Gowda, Secretary General, Indian Weightlifting Federation C-2/18, SECTOR - 31, NOIDA, UTTAR PRADESH 201301 (INDIA)</div>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* Mobile Footer - Hidden by default, shown on mobile */}
          <div className="vc_row wpb_row vc_row-fluid desktop-hide m__footer" style={styles.mobileFooter}>
            <div className="wpb_column vc_column_container">
              <div className="wpb_single_image footer_logo_m" style={{ textAlign: 'center', marginBottom: '1.5rem' }}>
                <img 
                  width="97" 
                  height="160" 
                  src="https://iwlf.in/wp-content/uploads/2025/06/iwlf-footer-logo.png" 
                  alt="IWLF Footer Logo" 
                  loading="lazy"
                  style={{ maxWidth: '97px', height: 'auto' }}
                />
              </div>
              {/* Mobile menu sections would go here - typically accordion style */}
            </div>
          </div>
        </div>
      </div>

      {/* Copyright Section */}
      <div className="gt-copyright" style={styles.copyright}>
        <div className="container footer_container" style={styles.copyrightContainer}>
          <div className="column_f fb_cpr">
            <p style={styles.copyrightText}>Copyright {currentYear} IWLF, All rights reserved.</p>
          </div>
          <div className="column_f fb_l">
            <ul className="footer_icon_list" style={styles.footerIconList}>
              <li><img src="https://iwlf.in/wp-content/uploads/2025/06/01-ilift-clean.png" alt="iLift Clean" style={styles.partnerLogo} /></li>
              <li><img src="https://iwlf.in/wp-content/uploads/2025/06/02-department-of-sports.png" alt="Department of Sports" style={styles.partnerLogo} /></li>
              <li><img src="https://iwlf.in/wp-content/uploads/2025/06/03-commonwealth-weightlifting-championship.png" alt="Commonwealth Weightlifting" style={styles.partnerLogo} /></li>
              <li><img src="https://iwlf.in/wp-content/uploads/2025/06/04-sports-authority-of-gujarat.png" alt="Sports Authority of Gujarat" style={styles.partnerLogo} /></li>
              <li><img src="https://iwlf.in/wp-content/uploads/2025/06/05-sports-authority-of-india.png" alt="Sports Authority of India" style={styles.partnerLogo} /></li>
            </ul>
          </div>
          <div className="column_f fb_sl">
            <ul className="footer_slnks" style={styles.footerSlnks}>
              <li><a href="https://www.facebook.com/indianweightlifting/" style={styles.socialLink}><i className="fab fa-facebook-f"></i></a></li>
              <li><a href="https://www.instagram.com/indian__weightlifting/" style={styles.socialLink}><i className="fab fa-instagram"></i></a></li>
              <li><a href="https://twitter.com/weightliftingin" style={styles.socialLink}><i className="fab fa-twitter"></i></a></li>
              <li><a href="#" style={styles.socialLink}><i className="fab fa-linkedin-in"></i></a></li>
              <li><a href="https://www.youtube.com/channel/UCvAB10JIrnL2WKu0_en7O-Q" style={styles.socialLink}><i className="fab fa-youtube"></i></a></li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
};

const styles = {
  footer: {
    background: '#191c41',
    color: '#e5e7eb',
    padding: '4rem 0 0',
    marginTop: 'auto',
    fontFamily: "'Oswald', sans-serif",
  },
  desktopFooter: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: '2rem',
    padding: '0 1rem 3rem',
    maxWidth: '1200px',
    margin: '0 auto',
    flexWrap: 'wrap',
  },
  mobileFooter: {
    display: 'none',
  },
  logoColumn: {
    width: '20%',
    minWidth: '150px',
  },
  column: {
    width: '23%',
    minWidth: '200px',
    display: 'flex',
    flexDirection: 'column',
  },
  columnTitle: {
    fontSize: '1.25rem',
    fontWeight: '600',
    color: '#ffffff',
    marginBottom: '0.5rem',
    fontFamily: "'Oswald', sans-serif",
  },
  logoImg: {
    maxWidth: '97px',
    height: 'auto',
    objectFit: 'contain',
  },
  iconList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.75rem',
    listStyle: 'none',
    paddingLeft: 0,
  },
  contactItem: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '0.75rem',
    color: '#9ca3af',
    fontSize: '0.925rem',
  },
  icon: {
    color: '#ffffff',
    marginTop: '3px',
    fontSize: '1rem',
  },
  linkList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.625rem',
    listStyle: 'none',
    paddingLeft: 0,
  },
  link: {
    color: '#9ca3af',
    textDecoration: 'none',
    fontSize: '0.925rem',
    transition: 'all 0.3s ease',
  },
  copyright: {
    borderTop: '1px solid rgba(255, 255, 255, 0.1)',
    padding: '1.5rem 0',
  },
  copyrightContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '0 1rem',
    flexWrap: 'wrap',
    gap: '1rem',
  },
  copyrightText: {
    margin: 0,
    fontSize: '0.875rem',
    color: '#9ca3af',
  },
  footerIconList: {
    display: 'flex',
    listStyle: 'none',
    paddingLeft: 0,
    alignItems: 'center',
    justifyContent: 'center',
    gap: '20px',
    marginBottom: 0,
  },
  partnerLogo: {
    maxHeight: '40px',
    width: 'auto',
  },
  footerSlnks: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    listStyle: 'none',
    gap: '15px',
    marginBottom: 0,
    paddingLeft: 0,
  },
  socialLink: {
    color: '#9ca3af',
    textDecoration: 'none',
    transition: 'all 0.3s ease',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '1.2rem',
  },
};

// Add responsive styles and hover effects
if (typeof document !== 'undefined') {
  const styleSheet = document.createElement('style');
  styleSheet.innerText = `
    footer a:hover {
      color: #ffffff !important;
      transform: translateX(3px);
    }
    
    footer .footer_slnks a:hover {
      transform: scale(1.1);
    }

    @media (max-width: 990px) {
      .mobile-hide {
        display: none !important;
      }
      
      .desktop-hide {
        display: block !important;
      }
      
      .footer_container {
        flex-direction: column !important;
        text-align: center !important;
      }
      
      .column_f {
        width: 100% !important;
      }
      
      footer .footer_icon_list {
        flex-wrap: wrap;
        gap: 15px !important;
      }
      
      footer .footer_icon_list li img {
        max-height: 30px !important;
      }
    }
  `;
  document.head.appendChild(styleSheet);
}

export default Footer;
